module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text2/13-ffb2e8d0779cc8ea7d83ee8cc6f72bbf.jpg";